import { render, staticRenderFns } from "./AddEditCertificates.vue?vue&type=template&id=64267e1e&scoped=true"
import script from "./AddEditCertificates.vue?vue&type=script&lang=js"
export * from "./AddEditCertificates.vue?vue&type=script&lang=js"
import style0 from "./AddEditCertificates.vue?vue&type=style&index=0&id=64267e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64267e1e",
  null
  
)

export default component.exports